import { render, staticRenderFns } from "./AccionesMasivas.vue?vue&type=template&id=81520620&"
import script from "./AccionesMasivas.vue?vue&type=script&lang=js&"
export * from "./AccionesMasivas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports